import { useContext } from "react";
import AuthContext from "@context/AuthContext";
import CourseContext from "@context/CourseContext";
import LearnContext from "@context/LearnContext";
import NavigationContext from "@context/NavigationContext";
import ProjectionContext from "@context/projection";
import QuestionnaireContext from "@context/QuestionnaireContext";
import UIContext from "@context/UIContext";

const useAuthContext = () => useContext(AuthContext);
const useCourseContext = () => useContext(CourseContext);
const useLearnContext = () => useContext(LearnContext);
const useNavigation = () => useContext(NavigationContext);
const useProjectionContext = () => useContext(ProjectionContext);
const useQuestionnaireContext = () => useContext(QuestionnaireContext);
const useUIContext = () => useContext(UIContext);

export {
    useAuthContext,
    useCourseContext,
    useLearnContext,
    useNavigation,
    useProjectionContext,
    useQuestionnaireContext,
    useUIContext,
};
